import { Button } from "antd";
import React from "react";
import { ArrowUpIcon } from "../../assets/icons";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import SummaryCreationData from "./components/SummaryCreationData";
import UsageStatistics from "./components/UsageStatistics";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../auth/userRoles.enum";
import { useTranslation } from "../../i18n/LanguageContext";

const AccountSummary = () => {
   const { t } = useTranslation();
   const navigate = useNavigate();
   const isSuperAdmin = AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);

   return (
      <>
         <div className="accountSummaryContainer d-flex flex-column">
            <div className="mainSection">
               <div className="d-flex flex-column" style={{ gap: "24px" }}>
                  <label className="labelStatusMain">{t("account-summary-label")}</label>
                  {
                     isSuperAdmin &&
                     <div className="summary-main">
                        <label className="labelTitle">
                           {t("account-summary-upgrade-message")}
                        </label>
                        <Button
                           icon={<img src={ArrowUpIcon} alt="" />}
                           className="upgrade"
                           onClick={() => navigate("/admin/payment-information")}
                        >
                           {t("upgrade-package-button")}
                        </Button>
                     </div>
                  }
                  <SummaryCreationData />
                  {isSuperAdmin && <UsageStatistics />}
               </div>
            </div>
         </div>
      </>
   );
};

export default AccountSummary;
